var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxWrapperYelloish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 413.81 222.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "BoxArea",
    d: "M411.364,224.829l-68.191-.048-68.367-2.056-68.367,1.8-68.364,1.835L69.71,223.721l-62.923.72L4.631,114.823,1.3,78.123l.737-35.082L2.2,5.2,69.7,4.3l68.369,2.369L206.44,6.8,274.8,3.811,343.171,5.1l69.474-1,1.291,37.324,1.17,36.7-.425,36.7-3.267,34.172.346,39.231Z",
    transform: "translate(-1.296 -3.811)",
    fill: "#fef1d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxWrapperYelloish);
export default __webpack_public_path__ + "static/media/BoxWrapper_yelloish.02279eddb8ec5dd5d342e1117a9dbd59.svg";
export { ForwardRef as ReactComponent };